import { useState } from 'react';
import { GIT_SETTINGS_MODES } from '../git-settings.utils';
import { isEqual } from 'lodash';

const useTeamModeHandler = ({ gitTeamSettings }) => {
  const [selectedReposIds, setSelectedReposIds] = useState(
    gitTeamSettings.reposIds
  );
  const [selectedServicesIds, setSelectedServicesIds] = useState(
    gitTeamSettings.servicesIds
  );
  const [isSaving, setIsSaving] = useState(false);
  const [isSelectedOnly, setIsSelectedOnly] = useState(false);

  const updateSelection = (isSelected, itemId, setItems) => {
    setItems(prev =>
      isSelected ? [...prev, itemId] : prev.filter(id => id !== itemId)
    );
  };

  const toggleRepoSelection = (repo, isSelected) =>
    updateSelection(isSelected, repo?.id, setSelectedReposIds);

  const toggleServiceSelection = (service, isSelected) =>
    updateSelection(isSelected, service?.id, setSelectedServicesIds);

  const isSaveDisabled =
    isSaving ||
    (isEqual(gitTeamSettings.reposIds, selectedReposIds) &&
      isEqual(gitTeamSettings.servicesIds, selectedServicesIds));

  const onSave = async () => {
    setIsSaving(true);
    await gitTeamSettings.onSave({
      repositoriesIds: selectedReposIds,
      servicesIds: selectedServicesIds
    });
    setIsSaving(false);
  };

  return {
    type: GIT_SETTINGS_MODES.TEAM,
    team: gitTeamSettings.team,
    selectedReposIds,
    selectedServicesIds,
    toggleRepoSelection,
    toggleServiceSelection,
    isSelectedOnly,
    setIsSelectedOnly,
    isSaveDisabled,
    onSave
  };
};

export default useTeamModeHandler;
